export const ELECTION_NAMES = {
  GENERAL: 'generales',
  REGIONAL: 'autonómicas',
  MUNICIPAL: 'municipales',
  EUROPEAN: 'europeas'
};
